import crudState from '../utils/crud/state'
import * as crudGetters from '../utils/crud/getters'
import * as crudMutations from '../utils/crud/mutations'
import * as crudActions from '../utils/crud/actions'
import CryptoJS from 'crypto-js'
import axios from '@/plugins/axios'

export default {
  namespaced: true,
  state: () => ({
    endpoint: 'prparametrosper',
    chatbotOpenai: '',
    chatbotEmail: '',
    chatbotConfig: '',
    chatbotClient: '',
    chatbotSecret: '',
    ...crudState()
  }),
  getters: {
    chatbotKeys(state) {
      return {
        chatbotOpenai: state.chatbotOpenai,
        chatbotEmail: state.chatbotEmail,
        chatbotConfig: state.chatbotConfig,
        chatbotClient: state.chatbotClient,
        chatbotSecret: state.chatbotSecret,
      }
    },
    ...crudGetters
  },
  mutations: {
    setChatbotKey(state, {key, value}) {
      state[key] = value
    },
    ...crudMutations
  },
  actions: {
    async decryptChatbotKeys({commit}) {
      const llave = 'oasisriveroasisr'
      const key = CryptoJS.enc.Utf8.parse(llave)
      
      const allParameters = await axios.get('prparametrosper/get')

      const chatbotParameters = allParameters.data.data.reduce(
        (object, item) => {
          if(item.key.startsWith('chatbot_')) {
            object[item.key] = item.value
          }
          return object
        },{}
      )
      
      if(chatbotParameters?.chatbot_openai) {
        const chatbotOpenai = CryptoJS.AES.decrypt(chatbotParameters.chatbot_openai, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
        const chatBotOpenaiDecrypted = CryptoJS.enc.Utf8.stringify(chatbotOpenai).toString()
        commit('setChatbotKey', {key:'chatbotOpenai', value: chatBotOpenaiDecrypted})
      }
      
      if(chatbotParameters?.chatbot_email) {
        const chatbotEmail = CryptoJS.AES.decrypt(chatbotParameters.chatbot_email, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
        const chatbotEmailDecrypted = CryptoJS.enc.Utf8.stringify(chatbotEmail).toString()
        commit('setChatbotKey', {key:'chatbotEmail', value: chatbotEmailDecrypted})
      }
      
      if(chatbotParameters?.chatbot_config) {
        const chatbotConfig = CryptoJS.AES.decrypt(chatbotParameters.chatbot_config, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
        const chatbotConfigDecrypted = CryptoJS.enc.Utf8.stringify(chatbotConfig).toString()
        commit('setChatbotKey', {key:'chatbotConfig', value: chatbotConfigDecrypted})
      }
      
      if(chatbotParameters?.chatbot_ck) {
        const chatbotClient = CryptoJS.AES.decrypt(chatbotParameters.chatbot_ck, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
        const chatbotClientDecrypted = CryptoJS.enc.Utf8.stringify(chatbotClient).toString()
        commit('setChatbotKey', {key:'chatbotClient', value: chatbotClientDecrypted})
      }
      
      if(chatbotParameters?.chatbot_sk) {
        const chatbotSecret = CryptoJS.AES.decrypt(chatbotParameters.chatbot_sk, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
        const chatbotSecretDecrypted = CryptoJS.enc.Utf8.stringify(chatbotSecret).toString()
        commit('setChatbotKey', {key:'chatbotSecret', value: chatbotSecretDecrypted})
      }
    },
    ...crudActions
  }
}
